<!-- @let appointments = dataSource; -->


<eretail-modal class="p-3 align-items-center position-relative" [isCloseable]="true" [basePadding]="false">

      <!-- <div class="close-button__container">
        <app-button icon="x-lg" buttonClass="bt-danger" mat-dialog-close buttonType="close"/>
    
      </div> -->
    
    <eretail-content-wrapper-header
      class="w-100"
      title="Envio de relatórios"
      subTitle="Novo Agendamento"
    />
    
    <eretail-dynamic-form
        #form
        class="eretail-form-sm"
        [dynForm]="newReportForm"
    >
      <app-button
        (clicked)="onSubmit()"
        formActionSectionItem
        class="w-100"
        buttonClass="bt-primary w-100"
        >
        Agendar
      </app-button>
    </eretail-dynamic-form>
      
</eretail-modal>

